module.exports = __webpack_public_path__ + "static/media/Dance of The Degens.fe528543.png";